/* -----------------------------------------------
/* How to use? : Check the GitHub README
/* ----------------------------------------------- */

/* To load a config file (particles.json) you need to host this demo (MAMP/WAMP/local)... */
/*
particlesJS.load('particles-js', 'particles.json', function() {
  console.log('particles.js loaded - callback');
});
*/

/* Otherwise just put the config content (json): */

// particlesJS('particles-js',
  
//   {
//     "particles": {
//       "number": {
//         "value": 150,
//         "density": {
//           "enable": true,
//           "value_area": 1200
//         }
//       },
//       "color": {
//         "value": "#fff"
//       },
//       "shape": {
//         "type": "polygon",
//         "stroke": {
//           "width": 0,
//           "color": "#000000"
//         },
//         "polygon": {
//           "nb_sides": 6
//         },
//         "image": {
//           "src": "img/flowapp.png",
//           "width": 100,
//           "height": 100
//         }
//       },
//       "opacity": {
//         "value": 0.05,
//         "random": true,
//         "anim": {
//           "enable": true,
//           "speed": 0.32,
//           "opacity_min": 0.05,
//           "sync": true
//         }
//       },
//       "size": {
//         "value": 5,
//         "random": true,
//         "anim": {
//           "enable": false,
//           "speed": 3,
//           "size_min": 3.9,
//           "sync": false
//         }
//       },
//       "line_linked": {
//         "enable": true,
//         "distance": 200,
//         "color": "#fff",
//         "opacity": .6,
//         "width": 0.2
//       },
//       "move": {
//         "enable": true,
//         "speed": .8,
//         "direction": "top-left",
//         "random": true,
//         "straight": false,
//         "out_mode": "out",
//         "attract": {
//           "enable": false,
//           "rotateX": 600,
//           "rotateY": 800
//         }
//       }
//     },
//     "interactivity": {
//       "detect_on": "canvas",
//       "events": {
//         "onhover": {
//           "enable": true,
//           "mode": "grab"
//         },
//         "onclick": {
//           "enable": false,
//           "mode": "push"
//         },
//         "resize": true
//       },
//       "modes": {
//         "grab": {
//           "distance": 400,
//           "line_linked": {
//             "opacity": 0.5
//           }
//         },
//         "bubble": {
//           "distance": 400,
//           "size": 4,
//           "duration": 0.3,
//           "opacity": 1,
//           "speed": 3
//         },
//         "": {
//           "distance": 200
//         },
//         "push": {
//           "particles_nb": 4
//         },
//         "remove": {
//           "particles_nb": 2
//         }
//       }
//     },
//     "retina_detect": true,
//     "config_demo": {
//       "hide_card": false,
//       "background_color": "#342f30",
//       "background_image": "",
//       "background_position": "50% 50%",
//       "background_repeat": "no-repeat",
//       "background_size": "cover"
//     }
//   }

// );



